import { ProductSourceDtoSourceEnum } from "definitions/product-storage";
import { FC, SVGProps } from "react";
import {
  DewuLogo,
  GoatLogo,
  PoizonComLogo,
  ShihuoLogo,
} from "src/components/Icons";

export type SourceCode = ProductSourceDtoSourceEnum;

export interface SourceInfo {
  code: SourceCode;
  label: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
}

export const SOURCE_INFO: Record<SourceCode, SourceInfo> = {
  [ProductSourceDtoSourceEnum.Dewu]: {
    code: ProductSourceDtoSourceEnum.Dewu,
    label: "Dewu",
    Icon: DewuLogo,
  },
  [ProductSourceDtoSourceEnum.Poizon]: {
    code: ProductSourceDtoSourceEnum.Poizon,
    label: "Poizon",
    Icon: PoizonComLogo,
  },
  [ProductSourceDtoSourceEnum.Goat]: {
    code: ProductSourceDtoSourceEnum.Goat,
    label: "GOAT",
    Icon: GoatLogo,
  },
  [ProductSourceDtoSourceEnum.Shihuo]: {
    code: ProductSourceDtoSourceEnum.Shihuo,
    label: "Shihuo",
    Icon: ShihuoLogo,
  },
};

export const SOURCE_LIST: SourceInfo[] = Object.values(
  ProductSourceDtoSourceEnum,
).map((code) => SOURCE_INFO[code]);

export const isSourceCode = (value: string): value is SourceCode =>
  Object.prototype.hasOwnProperty.call(SOURCE_INFO, value);
